import { z } from 'zod'

import { rateSchema } from 'shared/api/requests/aiConversationFeedback/schemas'
import { SocketEventBaseSchema } from 'utils/services/notificationsService/constants'

export const AiConversationsRateSocketEventsSchemas = {
  feedbackLeft: SocketEventBaseSchema.extend({
    event: z.literal('ai_conversation_feedback_left'),
    data: rateSchema,
  }),
}
